import { query, collection, where, orderBy, onSnapshot, serverTimestamp, setDoc, doc, addDoc, deleteDoc, getDocs, getDoc } from "firebase/firestore";
import { save } from "ionicons/icons";
import { getClient } from "./clients";
import { db, getCompanyId, getCurrentUser, sendError, getCurrentUserUID, isValidId, saveRecordPermissions } from "./firebase";
import { getUser } from "./users";

const eventListeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotAllList: any[] = [];
var lastSnapshotAllList: any[] = [];
var currentDate = new Date();
var userIds: number[] = [];
var blockClientEventQuery = false;
var lastClientEventListId: string = "";
var lastClientEventList: any = [];
currentDate.setUTCDate(15);

export function setEventUsers(users: any) {
    //console.log("setEventUsers", users)
    userIds = [];
    for (var i = 0; i < users.length; i++) {
        userIds.push(users[i].id);
    }
    var usersEventList = getLastSnapshotUsersList();
    eventListeners.forEach(callback => {
        callback(usersEventList);
    });
}

export async function registerEventSnapshotListener(clear = false) {
    if (clear) {
        await unregisterEventSnapshotListener()
    }
    if (snapshotListener !== null) {
        return;
    }
    if (getCurrentUser().resources.length === 0) {
        return;
    }
    var startDate = new Date(currentDate);
    var endDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() - 25);
    endDate.setDate(currentDate.getDate() + 25);
    var q = query(collection(db, 'companies/' + getCompanyId() + '/events'), where("start", ">=", startDate), where("start", "<=", endDate), where('resourceId', 'in', getCurrentUser().resources));
    if (getCurrentUser().onlyOwnEvents) {
        q = query(collection(db, 'companies/' + getCompanyId() + '/events'), where("start", ">=", startDate), where("start", "<=", endDate), where('userId', '==', getCurrentUserUID()));
    }
    //console.log("register eventListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: { id: any; owner: any; resourceId: any; comments: any; managerComments: any; start: any; end: any; clientId: any, userId: any, created: any, updated: any, smsList: [], serviceId: any, price: number, confirmed: boolean, confirmedDate: any, confirmedIp: string, status: number, connectedId: string, reminderSended: boolean }[] = [];
        data.forEach(function (doc: any) {
            const d = doc.data();
            //resource musi być stringiem
            var e = { id: doc.id, owner: d.owner ?? d.user ?? '', resourceId: d.resourceId + "", comments: d.comments, managerComments: d.managerComments, start: d.start.toDate(), end: d.end.toDate(), clientId: d.clientId ?? '', userId: d.userId ?? '', created: d.created, updated: d.updated, smsList: d.smsList, serviceId: d.serviceId ?? "0", price: d.price ?? 0, confirmed: d.confirmed ?? false, confirmedDate: d.confirmedDate?.toDate() ?? null, confirmedIp: d.confirmedIp ?? null, status: d.status ?? 1, connectedId: d.connectedId ?? "", reminderSended: d.reminderSended ?? false }
            if (e.smsList !== undefined) {
                for (var i = 0; i < e.smsList.length; i++) {
                    e.smsList[i].date = e.smsList[i].date.toDate();
                }
            }
            getClient(e.clientId);
            list.push(e);
        });
        lastSnapshotAllList = list;
        var usersEventList = getLastSnapshotUsersList();
        eventListeners.forEach(callback => {
            callback(usersEventList);
        });

    }, (err) => {
        console.log("onResourcesChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterEventSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister eventSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

function getLastSnapshotUsersList() {
    if (userIds.length === 0) {
        //console.log("getLastSnapshotUsersList all", lastSnapshotAllList);
        return lastSnapshotAllList;
    } else {
        var r = [];
        for (var i = 0; i < lastSnapshotAllList.length; i++) {
            if (userIds.includes(lastSnapshotAllList[i].userId)) {
                r.push(lastSnapshotAllList[i]);
            }
        }
        //console.log("getLastSnapshotUsersList", r);
        return r;
    }
}

export async function addEventListener(callback: CallableFunction) {
    eventListeners.push(callback);
    callback(getLastSnapshotUsersList());
}

function getEvent(id: string) {
    for (var i = 0; i < lastSnapshotAllList.length; i++) {
        if (lastSnapshotAllList[i].id === id) {
            return lastSnapshotAllList[i];
        }
    }
    return undefined;
}

function normalizeEventForCompare(data: any) {
    return {
        comments: data?.comments ?? '',
        managerComments: data?.managerComments ?? '',
        start: data?.start instanceof Date ? data.start.getTime() : new Date(data?.start).getTime(),
        end: data?.end instanceof Date ? data.end.getTime() : new Date(data?.end).getTime(),
        resourceId: data?.resourceId ?? '',
        clientId: data?.clientId ?? '',
        serviceId: data?.serviceId ?? '',
        userId: data?.userId ?? '',
        price: Number(data?.price ?? 0),
        confirmed: Boolean(data?.confirmed),
        status: Number(data?.status ?? 1),
        connectedId: data?.connectedId ?? ''
    };
}

function buildEventChangeList(before: any, after: any) {
    const fields = ['comments', 'managerComments', 'start', 'end', 'resourceId', 'clientId', 'serviceId', 'userId', 'price', 'confirmed', 'status', 'connectedId'];
    const changes: { field: string; previous: any; next: any }[] = [];
    fields.forEach((field) => {
        if (before[field] !== after[field]) {
            changes.push({ field, previous: before[field], next: after[field] });
        }
    });
    return changes;
}

async function saveEventLog(eventId: string, changes: { field: string; previous: any; next: any }[], mode: string = 'update') {
    if (changes.length === 0) {
        return;
    }
    try {
        await addDoc(collection(db, 'companies/' + getCompanyId() + '/events/' + eventId + '/log'), {
            owner: getCurrentUserUID(),
            created: serverTimestamp(),
            mode,
            changes
        });
    } catch (error) {
        console.error('saveEventLog error', error);
    }
}

export async function getEventLogs(eventId: string) {
    if (!eventId) {
        return [];
    }
    try {
        const q = query(collection(db, 'companies/' + getCompanyId() + '/events/' + eventId + '/log'), orderBy('created', 'desc'));
        const snapshot = await getDocs(q);
        const list: any[] = [];
        snapshot.forEach((d) => {
            const data: any = d.data();
            list.push({
                id: d.id,
                owner: data.owner ?? '',
                mode: data.mode ?? 'update',
                created: data.created?.toDate ? data.created.toDate() : null,
                changes: data.changes ?? []
            });
        });
        return list;
    } catch (error) {
        console.error('getEventLogs error', error);
        return [];
    }
}

export function duplicateEvent(data: any) {
    //console.log("duplicateEvent", data);
    var e = data.event;//getEvent(data.eventId);
    //console.log("duplicateEvent", e);
    if (e !== undefined) {
        e.connectedId = e.id;
        addEvent(e);
        for (var i = 0; i < data.occurrences; i++) {
            e = JSON.parse(JSON.stringify(e));
            //console.log("duplicateEvent", e);
            e.connectedId = data.event.id;
            e.id = null;
            e.confirmed = false;
            e.created = null;
            e.smsList = null;
            e.status = 1;
            e.start = new Date(e.start);
            switch (data.period) {
                case 0:
                    e.start.setDate(e.start.getDate() + 7);
                    break;
                case 1:
                    e.start.setDate(e.start.getDate() + 14);
                    break;
                case 2:
                    e.start.setDate(e.start.getDate() + 21);
                    break;
                case 3:
                    e.start.setDate(e.start.getDate() + 28);
                    break;
                case 4:
                    do {
                        e.start.setDate(e.start.getDate() + 1);
                    } while (e.start.getDay() < 1 || e.start.getDay() > 5);
                    break;
            }
            addEvent(e);
        }
    }
}

//jak wydarzenie zostało przypisane do uzytkownika, ktory nie ma praw do klienta to z automatu przypisuje prawa do odczytu
function updatePermissions(data: any) {
    if (isValidId(data.clientId) && isValidId(data.userId)) {
        let client = getClient(data.clientId);
        if (client.userId === data.userId) {
            //console.log("addEvent-permissions no update - owner", data.userId)
        } else {

            if (client.hasOwnProperty("permissions") && client.permissions.hasOwnProperty(data.userId) && client.permissions[data.userId] !== 'none') {
                //console.log("addEvent-permissions no update", data.userId, client.permissions)
                //ma uprawnienia
            } else {
                var permissions = client.permissions;
                if (permissions === undefined || permissions === null) {
                    permissions = {};
                }
                permissions[data.userId] = 'read';
                //console.log("addEvent-permissions update", data.userId, permissions)
                saveRecordPermissions("clients", data.clientId, permissions, client.updated);
            }
        }
    }
}

export async function addEvent(data: any, allInFuture: boolean = false) {
    //console.log("addEvent", data);
    var start = new Date(data.start);
    var end = new Date(start.getTime() + (data.time * 60 * 1000));

    var saveData = {
        comments: data.comments,
        managerComments: data.managerComments,
        start: start,
        end: end,
        resourceId: data.resourceId,
        clientId: data.clientId,
        serviceId: data.serviceId,
        updated: serverTimestamp(),
        userId: data.userId,
        price: data.price,
        confirmed: data.confirmed,
        status: data.status,
        connectedId: data.connectedId !== undefined ? data.connectedId : "",
        weekday: start.getDay()
    };

    if (data.id !== null && data.id !== undefined) {
        let currentEvent = getEvent(data.id);
        if (!currentEvent) {
            try {
                const eventDoc = await getDoc(doc(db, 'companies/' + getCompanyId() + '/events', data.id));
                if (eventDoc.exists()) {
                    const d: any = eventDoc.data();
                    currentEvent = {
                        comments: d.comments,
                        managerComments: d.managerComments,
                        start: d.start?.toDate ? d.start.toDate() : d.start,
                        end: d.end?.toDate ? d.end.toDate() : d.end,
                        resourceId: d.resourceId,
                        clientId: d.clientId,
                        serviceId: d.serviceId,
                        userId: d.userId,
                        price: d.price,
                        confirmed: d.confirmed,
                        status: d.status,
                        connectedId: d.connectedId
                    };
                }
            } catch (error) {
                console.error('addEvent getDoc before compare error', error);
            }
        }

        const beforeMain = currentEvent ? normalizeEventForCompare(currentEvent) : null;
        const afterMain = normalizeEventForCompare(saveData);
        const mainChanges = beforeMain ? buildEventChangeList(beforeMain, afterMain) : [];

        if (!allInFuture && beforeMain && mainChanges.length === 0) {
            return;
        }

        try {
            await setDoc(doc(db, 'companies/' + getCompanyId() + '/events', data.id), saveData, { merge: true });
            await saveEventLog(data.id, mainChanges);
            sendError("Poprawiono Wydarzenie!");
            updatePermissions(data);


            if (allInFuture) {
                if (saveData.connectedId !== undefined && saveData.connectedId.length > 3) {
                    var q = query(collection(db, 'companies/' + getCompanyId() + '/events'), where("start", ">", saveData.start), where('connectedId', '==', saveData.connectedId));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((d) => {
                        let eventData = d.data();
                        const before = normalizeEventForCompare({
                            ...eventData,
                            start: eventData.start?.toDate ? eventData.start.toDate() : eventData.start,
                            end: eventData.end?.toDate ? eventData.end.toDate() : eventData.end
                        });
                        eventData.comments = saveData.comments;
                        eventData.managerComments = saveData.managerComments;
                        eventData.start = eventData.start.toDate();
                        eventData.start.setHours(start.getHours());
                        eventData.start.setMinutes(start.getMinutes());
                        eventData.end = eventData.end.toDate();
                        eventData.end.setHours(end.getHours());
                        eventData.end.setMinutes(end.getMinutes());
                        eventData.resourceId = saveData.resourceId;
                        eventData.clientId = saveData.clientId;
                        eventData.serviceId = saveData.serviceId;
                        eventData.updated = serverTimestamp();
                        eventData.userId = saveData.userId;
                        eventData.price = saveData.price;
                        const after = normalizeEventForCompare(eventData);
                        const changes = buildEventChangeList(before, after);
                        if (changes.length > 0) {
                            setDoc(doc(db, 'companies/' + getCompanyId() + '/events', d.id), eventData, { merge: true });
                            saveEventLog(d.id, changes, 'update-all-future');
                        }
                    });
                }
            }
        } catch (error) {
            console.error(error);
            sendError("Nie mozna poprawić Wydarzenia!");
        }

    } else {
        //@ts-ignore
        saveData.created = serverTimestamp();
        //@ts-ignore
        saveData.owner = getCurrentUserUID();
        try {
            await addDoc(collection(db, 'companies/' + getCompanyId() + '/events'), saveData);
            sendError("Dodano Wydarzenie!");
            updatePermissions(data);
        } catch (error) {
            console.error(error);
            sendError("Nie mozna dodać Wydarzenia!");
        }

    }
}

export async function removeEvent(id: string, allInFuture: boolean = false) {
    try {

        if (allInFuture) {
            let e = getEvent(id);
            if (e.connectedId !== undefined && e.connectedId.length > 3) {
                var q = query(collection(db, 'companies/' + getCompanyId() + '/events'), where("start", ">", e.start), where('connectedId', '==', e.connectedId));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((d) => {
                    deleteDoc(doc(db, 'companies/' + getCompanyId() + '/events', d.id));
                });
            }
        }
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/events', id));
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć Wydarzenia!");
    }

}

export function updateCurrentEventDate(date: Date) {
    if (currentDate.getMonth() !== date.getMonth() || currentDate.getFullYear() !== date.getFullYear()) {
        currentDate.setUTCDate(15);
        currentDate.setUTCMonth(date.getUTCMonth());
        currentDate.setUTCFullYear(date.getUTCFullYear());
        registerEventSnapshotListener(true);
    }

}

export async function getClientEvents(clientId: string, callback: CallableFunction) {
    if (lastClientEventListId === clientId) {
        callback(lastClientEventList);
    } else {
        if (!blockClientEventQuery) {
            blockClientEventQuery = true;
            //console.log("getClientEvents", clientId);
            var q = query(collection(db, 'companies/' + getCompanyId() + '/events'), where("clientId", "==", clientId), orderBy("start", "desc"));
            const querySnapshot = await getDocs(q);
            let data: any[] = [];
            querySnapshot.forEach((doc) => {
                let p: any = {};
                let d = doc.data();
                p.id = doc.id;
                p.start = d.start;
                p.user = getUser(d.userId);
                p.comments = d.comments;
                p.managerComments = d.managerComments;
                switch (d.status) {
                    case 1:
                        p.status = "umówiony";
                        break;
                    case 2:
                        p.status = "odwołany (klient)";
                        break;
                    case 3:
                        p.status = "odwołany (terapeuta)";
                        break;
                    case 4:
                        p.status = "nieobecny";
                        break;
                    case 5:
                        p.status = "zrealizowany";
                        break;
                }
                data.push(p);
            });
            //console.log(data);
            lastClientEventListId = clientId;
            lastClientEventList = data;
            callback(data);
            blockClientEventQuery = false;
        }
    }
}